<ng-template #templatePart>
  <div class="eos-learn-more" [ngStyle]="{ marginBottom: marginBottom }">
    <div (mouseenter)="showTooltip = true" (mouseleave)="showTooltip = false">
      <h4 class="fw-600 f-16 text-black">{{ title | translate | async }}
        <i *ngIf=" lps.isDismissed(slug)" [ngbPopover]="showTooltip ? popContent : null"
          triggers="mouseenter:click"
          placement="right" style="cursor: pointer">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.0001 18.3366C5.39771 18.3366 1.66675 14.6056 1.66675 10.0033C1.66675 5.40088 5.39771 1.66992 10.0001 1.66992C14.6024 1.66992 18.3334 5.40088 18.3334 10.0033C18.3334 14.6056 14.6024 18.3366 10.0001 18.3366ZM10.0001 16.6699C13.682 16.6699 16.6667 13.6852 16.6667 10.0033C16.6667 6.32135 13.682 3.33659 10.0001 3.33659C6.31818 3.33659 3.33341 6.32135 3.33341 10.0033C3.33341 13.6852 6.31818 16.6699 10.0001 16.6699ZM9.16675 5.83659H10.8334V7.50325H9.16675V5.83659ZM9.16675 9.16992H10.8334V14.1699H9.16675V9.16992Z" fill="#666666"/>
          </svg></i>
      </h4>
    </div>

    <ng-template #popContent>
      <p class="m-0" [innerHTML]="(content | translate | async)"></p>
      <div>
        <a class="text-black fw-500 f-14" target="_blank" style="cursor: pointer;"
        (click)="redirect(link || router_link)">{{ "Learn more" | translate | async }}</a>
        <!-- &nbsp;|
        <a class="text-black fw-600" href="#" (click)="lps.dismiss($event, slug)">Dismiss</a> -->
      </div>
    </ng-template>
    <ng-container *ngIf="!lps.isDismissed(slug)">
      <p class="eos-lm-description fw-500 pt-2 f-16 mb-1 text-gey" [innerHTML]="(content | translate | async)"></p>
      <div>
        <a class="text-black fw-500 f-14" target="_blank" style="cursor: pointer;"
        (click)="redirect(link || router_link)">{{ "Learn more" | translate | async }}</a>&nbsp;|
        <a class="text-black fw-500 f-14" href="#" (click)="lps.dismiss($event, slug)">{{ "Dismiss" | translate | async }}</a>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-container [ngSwitch]="template">
  <ng-container *ngSwitchCase="'wrapped'">
    <div class="learn-more-wrapped" [ngClass]="{ bordered }" [ngStyle]="{ marginBottom: marginBottom }">
      <ng-container *ngTemplateOutlet="templatePart"></ng-container>
    </div>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <ng-container *ngTemplateOutlet="templatePart"></ng-container>
  </ng-container>
</ng-container>
